import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import TextInput from "../common/formfields/TextInput"
import CheckboxInput from "../common/formfields/CheckboxInput"

const RegistrationForm = ({
    user,
    onRegister,
    onChange,
    processing = false,
    errors = {}
}) => {
    return (
        <div>
            <form>
                <h2>Sign Up</h2>
                <hr />
                {errors.onRegistration && (
                    <div className="alert alert-danger" role="alert">
                        {errors.onRegistration}
                    </div>
                )}

                <TextInput
                    name="firstName"
                    label="First Name"
                    type="text"
                    value={user.firstName}
                    onChange={onChange}
                    error={errors.firstName}
                />
                <TextInput
                    name="surname"
                    label="Surname"
                    type="text"
                    value={user.surname}
                    onChange={onChange}
                    error={errors.surname}
                />
                <TextInput
                    name="email"
                    label="Email Address"
                    type="email"
                    value={user.email}
                    onChange={onChange}
                    error={errors.email}
                />
                <TextInput
                    name="username"
                    label="Username"
                    type="text"
                    value={user.username}
                    onChange={onChange}
                    error={errors.username}
                />
                <TextInput
                    name="password"
                    label="Password"
                    type="password"
                    value={user.password}
                    onChange={onChange}
                    error={errors.password}
                />
                <TextInput
                    name="passwordConfirmation"
                    label="Confirm Password"
                    type="password"
                    value={user.passwordConfirmation}
                    onChange={onChange}
                    error={errors.passwordConfirmation}
                />
                
                <div className="form-group">
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="acceptTc"
                            name="acceptTc"
                            value={user.acceptTc}
                            onChange={onChange}
                        />
                        <label className="form-check-label" htmlFor="acceptTc">I agree to the sites <a href="/about/termsandconditions" target="_blank">Terms and Conditions</a></label>
                        {errors.acceptTc && <div className="alert alert-danger">{errors.acceptTc}</div>}
                    </div>
                </div>

                <button type="submit" onClick={onRegister} disabled={processing} className="btn btn-info float-right">
                    {processing ? "Processing..." : "Sign Up"}
                </button>
            </form>
        </div>


    );
}

RegistrationForm.propTypes = {
    user: PropTypes.object.isRequired,
    errors: PropTypes.object,
    onRegister: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    processing: PropTypes.bool
}

export default RegistrationForm;


//<CheckboxInput
//    name="acceptTc"
//    label="I agree"
//    value={user.acceptTc}
//    onChange={onChange}
//    error={errors.acceptTc}
///>


// WEBPACK FOOTER //
// ./src/components/user/RegistrationForm.js